import React from "react";
import LeadCTASection from "components/LeadCTASection";
import Footer from "components/Footer";
import HeroSection from "components/HeroSection";
import ProductHuntBanner from "components/ProductHuntBanner";
import VideoPreview from "components/VideoPreview";
import GetSupport from "./GetSupport";
import PATHS from "utils/paths";
import { formFactorAction } from "utils/view";
import { styles } from "./styles";
import { YOUTUBE_VIDEO_ID } from "utils/constants/video";

const HEADER = ["The fastest way to get paid by your supporters."];
const SUBHEADER = "No coding required. Free to start!";
const VIDEO_PROPS = {
  header: "See how it's made!",
  body: `${formFactorAction()} to see how you can build a creator page in just a few minutes. 🚀`,
  videoId: YOUTUBE_VIDEO_ID.PAGES_CREATORS
};

const MarketingPagesCreators = () => (
  <div className="w-100 relative">
    <ProductHuntBanner />
    <div className="mw8 center">
      <HeroSection header={HEADER} subheader={SUBHEADER} />
      <div className="dib mw6 center flex items-center justify-center w-100 ph3 ph0-ns">
        <VideoPreview {...VIDEO_PROPS} />
      </div>
      <div className="ph3">
        <GetSupport />
      </div>
    </div>
    <div className="pt3 mw8 center">
      <LeadCTASection
        header="Ready to build a payment page?"
        subheader="Click below to get started."
        action={{ href: PATHS.SIGNUP, copy: "Create page" }}
      />
    </div>
    {/* <!-- Footer  --> */}
    <div className="pt3">
      <div className="mw8 center hairline-1 bt">
        <Footer />
      </div>
    </div>
    <style jsx>{styles}</style>
  </div>
);

export default MarketingPagesCreators;
